<template>
  <div class="yht-backStage-zhgl">
    <div class="yht-backStage-zhgl-content">
      <div class="flex mb20">
        <div
          v-for="item in typeList"
          :key="item.id"
          class="yht-backStage-zhgl_typeBtn cp"
          :class="{'active' : item.id === typeSelect.id}"
          @click="clickType(item)"
          v-text="item.name"></div>
      </div>
      <div class="yht-backStage-zhgl-content_btnBox flex mb20">
        <div v-show="typeSelect.id === 1" class="yht-backStage-zhgl-content_btn cp" @click="openUserDialog">新增</div>
      </div>
      <div class="yht-backStage-zhgl-content_search">
        <el-input class="zhgl-input" placeholder="请输入用户名或邮箱进行检索···" v-model="keyWord" @keyup.enter.native="handleSearch"></el-input>
        <div class="yht-backStage-zhgl-content_search_icon cp" @click="handleSearch"></div>
      </div>
      <div class="yht-backStage-zhgl_table ">
        <el-table
          v-loading="loading"
          ref="table"
          height="calc(100% - 50px)"
          tooltip-effect="light"
          :data="zhglList">
          <el-table-column label="" width="20" key="1"></el-table-column>
          <el-table-column label="序号" width="80" type="index" key="3">
            <span slot-scope="scope">{{ scope.$index + (pageNo - 1) * pageSize + 1 }}</span>
          </el-table-column>
          <el-table-column prop="name" label="用户名" width="200" key="4">
            <span class="cp" @click="getPermission(scope.row)" slot-scope="scope" :title="scope.row.name">{{scope.row.name}}</span>
          </el-table-column>
          <el-table-column prop="userName" label="真实姓名" key="5">
            <span slot-scope="scope" :title="scope.row.userName">{{scope.row.userName}}</span>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" key="6">
            <span slot-scope="scope" :title="scope.row.phone">{{scope.row.phone}}</span>
          </el-table-column>
          <el-table-column prop="mail" label="邮箱" key="7">
            <span slot-scope="scope" :title="scope.row.mail">{{scope.row.mail}}</span>
          </el-table-column>
          <el-table-column prop="departmentName" label="部门" key="8">
            <span slot-scope="scope" :title="scope.row.departmentName">{{scope.row.departmentName}}</span>
          </el-table-column>
          <el-table-column prop="positionName" label="岗位" key="9">
            <span slot-scope="scope" :title="scope.row.positionName">{{scope.row.positionName}}</span>
          </el-table-column>
          <el-table-column prop="islock" label="状态" key="10">
            <template slot-scope="scope">
              <span
                class="yht-backStage-zhgl_table_status"
                :class="{'online' : scope.row.islock === 0, 'offline' : scope.row.islock === 1}"
                v-text="scope.row.islock === 0? '正常' : '停用'"
                :title="scope.row.islock === 0? '正常' : '停用'"></span>
            </template>
          </el-table-column>
          <el-table-column label="操作" key="11">
            <template slot-scope="scope">
              <div
                class="yht-backStage-zhgl_table_line cp"
                :class="{'offline' : scope.row.islock === 0}"
                :title="scope.row.islock === 0 ? '停用' : '启用'"
                @click="singleOnOffLine(scope.row)"></div>
            </template>
          </el-table-column>
          <template slot="empty">
            <span class="mt10" style="display:block;font-size: 12px;color: #666666;">暂无查询数据</span>
          </template>
        </el-table>
        <!-- 页码 -->
        <div class="yht-backStage-zhgl_page yht-backStage-page">
          <el-pagination
            v-show="total>15 && !loading"
            background
            layout="total, prev, pager, next"
            :current-page="pageNo"
            :page-size="pageSize"
            :total="total"
            @current-change="changePage">
          </el-pagination>
        </div>
      </div>
      <!--上下线确认-->
      <div class="yht-backStage_dialog">
        <el-dialog :title="checkStatus === 0 ? '确认启用' : '确认停用'" width="400px" :visible="showBatch"
                   :close-on-click-modal="false"
                   :before-close="handleBatchCancel">
          <div class="te-center mt15">
            <div v-text="'用户名：' + selectObj.name"></div>
            <div class="mt20">
              账号将被<span v-text="checkStatus === 0 ? '启用' : '停用'"></span>
            </div>
          </div>
          <div class="yht-backStage_dialog_btnBox mt30">
            <div class="yht-backStage_dialog_btn yht-backStage_dialog_btnConfirm" @click="handleConfirm">确认</div>
            <div class="yht-backStage_dialog_btn yht-backStage_dialog_btnCancel" @click="handleBatchCancel">取消</div>
          </div>
        </el-dialog>
        <el-dialog title="新增机构用户" width="920px" :visible="showAddUser"
                   :close-on-click-modal="false"
                   :before-close="handleUserCancel">
          <div v-loading="loadingDepart">
            <div class="yht-backStage-zhgl_userInfo">
              <el-form ref="infoForm" :model="infoForm" :rules="inforules" label-position="right">
                <el-form-item label="用户名" prop="name" label-width="60px">
                  <el-input v-model="infoForm.name" placeholder="作为登录系统的用户名"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名" prop="userName" label-width="80px">
                  <el-input v-model="infoForm.userName" placeholder="账号使用人真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone" label-width="60px">
                  <el-input v-model="infoForm.phone" placeholder="账号使用人手机号"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password" label-width="60px">
                  <el-input v-model.trim="infoForm.password" show-password placeholder="至少12位，含大小写字母、数字、特殊符号"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword" label-width="80px">
                  <el-input v-model.trim="infoForm.confirmPassword" show-password placeholder="确认密码"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="mail" label-width="60px">
                  <el-input v-model="infoForm.mail" placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item label="部门" prop="departCheck" label-width="60px">
                  <el-cascader
                    ref="cascader"
                    class="yht-backStage-zhgl_cascader"
                    v-model="infoForm.departCheck"
                    :options="departmentList"
                    placeholder="选择部门"
                    :props="{ label:'name',value:'id' }"
                    :show-all-levels="false"
                    @change="handleChange">
                    <template slot-scope="{ node, data }">
                      <span :title="data.name">{{ data.name }}</span>
                    </template>
                  </el-cascader>
                </el-form-item>
                <el-form-item label="岗位" prop="positionNumber" label-width="80px">
                  <el-select class="yht-backStage-zhgl_select" v-model="infoForm.positionNumber" placeholder="请选择">
                    <el-option
                      v-for="m in positionList"
                      :key="m.correspondingId"
                      :label="m.positionName"
                      :value="m.correspondingId">
                      <span class="yht-backStage-zhgl_select_item text-ellipsis" :title="m.positionName">{{ m.positionName }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="yht-backStage-zhgl_privilege mt20">
              <div class="yht-backStage-zhgl_privilege_Liltitle mt30">课题协同研究平台</div>
              <div class="yht-backStage-zhgl_privilege_box">
                <div class="yht-backStage-zhgl_privilege_item flex" v-for="(itemS, indexS) in subjectPermissionList" :key="`subject${indexS}`">
                  <div class="yht-backStage-zhgl_privilege_check cp" @click="handleChecked(itemS)" :class="{'active' : itemS.checked === true}"></div>
                  <div class="yht-backStage-zhgl_privilege_name cp" @click="handleChecked(itemS)" v-text="itemS.name"></div>
                  <div class="yht-backStage-zhgl_privilege_description" v-text="'(' + itemS.description + ')'"></div>
                </div>
              </div>
              <div class="yht-backStage-zhgl_privilege_Liltitle mt30">门户后台管理系统（可多选）</div>
              <div class="yht-backStage-zhgl_privilege_box">
                <div class="yht-backStage-zhgl_privilege_item flex" v-for="(itemP, indexP) in portalPermissionList" :key="`portal${indexP}`">
                  <div class="yht-backStage-zhgl_privilege_check cp" @click="handleChecked(itemP)" :class="{'active' : itemP.checked === true}"></div>
                  <div class="yht-backStage-zhgl_privilege_name cp" @click="handleChecked(itemP)" v-text="itemP.name"></div>
                  <div class="yht-backStage-zhgl_privilege_description" v-text="'(' + itemP.description + ')'"></div>
                </div>
              </div>
            </div>
            <div class="yht-backStage-zhgl_btnBox mt30">
              <div class="yht-backStage-zhgl_btn te-center cp" @click="checkOrgan('infoForm')">保存</div>
            </div>
          </div>
        </el-dialog>
        <el-dialog title="查看权限" width="620px" :visible="showPermission"
                   :close-on-click-modal="false"
                   :before-close="handlePermissionCancel">
          <div class="mt15 font-s16" v-loading="loadingPermission">
            <div class="yht-backStage-permission_userName" v-text="'用户名：' + permissionObj.userName"></div>
            <div class="yht-backStage-permission_title mt20">系统权限：</div>
            <div class="flex mt10">
              <div>课题协同研究平台：</div>
              <div class="yht-backStage-permission_right" v-text="permissionObj.subjectPermission"></div>
            </div>
            <div class="flex mt10">
              <div>后台管理：</div>
              <div class="yht-backStage-permission_right" v-text="permissionObj.portalPermission"></div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { encryptRSA } from '../../../util/rsa'
import { validatePasswordStrength } from '../../../util/password'

export default {
  name: 'zhgl',
  data () {
    // 用户名校验
    const validateName = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9]+$/
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else if (value.length > 20) {
        callback(new Error('内容过长，请输入20个字符内的用户名！'))
      } else if (!reg.test(value)) {
        callback(new Error('用户名只支持英文字母和数字！'))
      } else {
        callback()
      }
    }

    // 真实姓名校验
    const validateUserName = (rule, value, callback) => {
      const reg = /^(?:[\u4e00-\u9fa5·]{2,16})$/
      if (value === '') {
        callback(new Error('请输入真实姓名'))
      } else if (value.length > 10) {
        callback(new Error('真实姓名输入10字以内'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确格式的真实姓名！'))
      } else {
        callback()
      }
    }

    // 手机号校验
    const validatePhone = (rule, value, callback) => {
      const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号格式！'))
      } else {
        callback()
      }
    }

    // 密码校验
    const validatePassword = (rule, value, callback) => {
      const errorMessage = validatePasswordStrength(value, this.infoForm.name)
      if (errorMessage) {
        callback(new Error(errorMessage))
      } else {
        if (this.infoForm.confirmPassword !== '') {
          this.$refs.infoForm.validateField('confirmPassword')
        }
        callback()
      }
    }

    // 确认密码校验
    const validateConfirmPassword = (rule, value, callback) => {
      const errorMessage = validatePasswordStrength(value, this.infoForm.name)
      if (errorMessage) {
        callback(new Error(errorMessage))
      } else if (value !== this.infoForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }

    // 邮箱校验
    const validateMail = (rule, value, callback) => {
      const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (value === '') {
        callback(new Error('请输入邮箱'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确格式的邮箱'))
      } else {
        callback()
      }
    }

    // 部门校验
    const validateDepartment = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请选择部门'))
      } else {
        callback()
      }
    }

    // 岗位校验
    const validatePosition = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择岗位'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      loadingPermission: false,
      // 查看权限对象
      permissionObj: {
        subjectPermission: [],
        portalPermission: []
      },
      // 查看权限弹窗的展示与否
      showPermission: false,
      typeList: [
        {
          name: '机构用户',
          id: 1
        }, {
          name: '互联网用户',
          id: 0
        }
      ],
      typeSelect: {
        name: '机构用户',
        id: 1
      },
      // 搜索框输入内容
      keyWord: '',
      // 账号管理表格list
      zhglList: [],
      // 搜索参数
      searchText: '',
      // 页数
      pageNo: 1,
      // 条数
      pageSize: 15,
      // 总数
      total: 0,
      // 上线还是下线
      checkStatus: 0,
      selectId: '',
      // 上下线确认框显示
      showBatch: false,
      // 选中的用户
      selectObj: { name: '' },
      // 新增机构用户弹框显示
      showAddUser: false,
      // 新增用户机构用户信息项
      infoForm: {
        // 用户名
        name: '',
        // 真实姓名
        userName: '',
        // 手机号
        phone: '',
        // 密码
        password: '',
        // 确认密码
        confirmPassword: '',
        // 邮箱
        mail: '',
        // 部门编号
        departmentNumber: '',
        departmentName: '',
        // 职位编号
        positionNumber: '',
        departCheck: []
      },
      // 部门list
      departmentList: [],
      // 岗位list
      positionList: [],
      loadingDepart: false,
      // 新增用户机构用户信息项校验规则
      inforules: {
        name: [
          { validator: validateName, trigger: 'blur' }
        ],
        userName: [
          { validator: validateUserName, trigger: 'blur' }
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ],
        mail: [
          { validator: validateMail, trigger: 'blur' }
        ],
        departCheck: [
          { validator: validateDepartment, trigger: 'change' }
        ],
        positionNumber: [
          { validator: validatePosition, trigger: 'change' }
        ]
      },
      // 课题协同研究平台
      subjectPermissionList: [
        {
          name: '课题提交',
          description: '作为科研人员，可通过申报、新建、认领等方式添加课题，提交课题材料',
          checked: false
        },
        {
          name: '课题评审',
          description: '作为评审专家，可评审分配给自己的课题',
          checked: false
        }
      ],
      portalPermissionList: [
        {
          name: '系统管理',
          description: '新增、管理机构账号，设置互联网用户状态，管理机构部门及岗位',
          checked: false
        },
        {
          name: '精品文物',
          description: '管理门户系统精品文物展示数据，设置数据是否在前端页面展示',
          checked: false
        },
        {
          name: '专题研究',
          description: '管理门户系统专题研究展示数据，设置数据是否在前端页面展示',
          checked: false
        }
      ]
    }
  },
  props: {
  },
  mounted () {
    this.getAccountPage()
  },
  methods: {
    // 点击分类
    clickType (param) {
      if (this.typeSelect === param) {
        return
      }
      this.typeSelect = param
      this.pageNo = 1
      this.keyWord = ''
      this.searchText = ''
      this.getAccountPage()
    },

    // 获取账号管理列表
    getAccountPage () {
      const self = this
      self.loading = true
      const data = {
        searchKey: this.searchText.trim(),
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        userKind: this.typeSelect.id
      }
      axios.post('/yuhuamenhu/accountManagement/getAccountPage', data).then(json => {
        if (json.data.code === 200) {
          self.zhglList = json.data.data.list
          self.total = json.data.data.total
        } else {
          self.$message.warning(json.data.message)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loading = false
      })
    },

    handleChange (value) {
      if (value.length === 0) {
        this.infoForm.departmentNumber = ''
        return
      }
      this.infoForm.departmentNumber = value.join('#')
      this.infoForm.departmentName = this.$refs.cascader.getCheckedNodes()[0].pathLabels.join('#')
    },

    // 检索功能
    handleSearch () {
      this.searchText = this.keyWord
      this.pageNo = 1
      this.getAccountPage()
    },

    // 点击分页
    changePage (val) {
      this.pageNo = val
      this.getAccountPage()
    },

    // 查看用户权限
    getPermission (param) {
      const self = this
      self.showPermission = true
      self.loadingPermission = true
      axios.get('/yuhuamenhu/accountManagement/getPermission', {
        params: {
          userId: param.id
        }
      }).then(json => {
        if (json.data.code === 200) {
          self.permissionObj = json.data.data
          self.permissionObj.subjectPermission = self.permissionObj.subjectPermission.join(',')
          self.permissionObj.portalPermission = self.permissionObj.portalPermission.join(',')
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loadingPermission = false
      })
    },

    handlePermissionCancel () {
      this.showPermission = false
    },

    // 关闭上下线弹窗
    handleBatchCancel () {
      this.selectId = ''
      this.$refs.table.clearSelection()
      this.showBatch = false
    },

    // 点击单独上下线
    singleOnOffLine (param) {
      this.selectObj = param
      this.selectId = param.id
      this.checkStatus = param.islock === 0 ? 1 : 0
      this.showBatch = true
    },

    // 账号启用停用
    handleConfirm () {
      const self = this
      const data = {
        status: this.checkStatus,
        id: this.selectId
      }
      axios.post('/yuhuamenhu/accountManagement/modifyStatus', data).then(json => {
        if (json.data.code === 200) {
          this.handleBatchCancel()
          this.getAccountPage()
          self.$message.success(json.data.data)
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 新增机构用户弹窗打开
    openUserDialog () {
      this.getAllDepartment()
      this.getAllPosition()
      this.showAddUser = true
    },

    // 关闭新增机构用户弹窗
    handleUserCancel () {
      this.$refs.infoForm.resetFields()
      this.subjectPermissionList.forEach(item => { item.checked = false })
      this.portalPermissionList.forEach(item => { item.checked = false })
      this.showAddUser = false
    },

    // 获取部门
    getAllDepartment () {
      const self = this
      self.loadingDepart = true
      axios.get('/yuhuamenhu/department/getAllDepartmentType').then(json => {
        if (json.data.code === 200) {
          self.departmentList = json.data.data
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loadingDepart = false
      })
    },

    // 获取岗位
    getAllPosition () {
      const self = this
      axios.get('/yuhuamenhu/position/getAllPons').then(json => {
        if (json.data.code === 200) {
          self.positionList = json.data.data
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 点击复选框
    handleChecked (item) {
      item.checked = !item.checked
    },

    // 保存前校验
    checkOrgan (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.applyOrgan()
        } else {
          this.$message.warning('请填写个人申请信息!')
          console.log('error submit!!')
          return false
        }
      })
    },

    applyOrgan () {
      // 选中的课题协同研究平台权限
      const subjectPermissionList = this.dealArray(this.subjectPermissionList)
      // 选中的门户后台管理系统权限
      const portalPermissionList = this.dealArray(this.portalPermissionList)
      // if (subjectPermissionList.length === 0 && portalPermissionList.length === 0) {
      //   this.$message.warning('请选择需要申请的系统权限!')
      //   return
      // }
      const self = this
      // 盐值
      // const salt = 'cnki-yyds*123.cv987@'
      const data = {
        // 用户名
        name: this.infoForm.name,
        // 真实姓名
        userName: this.infoForm.userName,
        // 手机号
        phone: this.infoForm.phone,
        // 密码
        password: encryptRSA(this.infoForm.password),
        // 确认密码
        confirmPassword: encryptRSA(this.infoForm.confirmPassword),
        // 邮箱
        mail: this.infoForm.mail,
        // 部门编号
        departmentNumber: this.infoForm.departmentNumber,
        // 部门名称
        departmentName: this.infoForm.departmentName,
        // 职位编号
        positionNumber: this.infoForm.positionNumber,
        // 选中的课题协同研究平台权限
        subjectPermissionList: subjectPermissionList,
        // 选中的门户后台管理系统权限
        portalPermissionList: portalPermissionList
      }
      axios.post('/yuhuamenhu/accountManagement/addOrganizationUser', data).then(json => {
        if (json.data.code === 200) {
          self.$message.success(json.data.data)
          this.handleUserCancel()
          this.getAccountPage()
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 处理数据
    dealArray (array) {
      const result = []
      array.forEach(item => {
        if (item.checked) {
          result.push({
            name: item.name,
            description: item.description
          })
        }
      })
      return result
    }
  }
}
</script>

<style>
  .yht-backStage-zhgl {
    padding-bottom: 40px;
    width: 100%;
    height: 100%;
  }

  .yht-backStage-zhgl-content {
    position: relative;
    padding: 30px;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background: #FFFFFF;
    box-shadow: 0 4px 50px 8px rgba(0, 0, 0, 0.06);
  }

  .yht-backStage-zhgl_typeBtn {
    margin-right: 34px;
    width: 126px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    border: 1px solid #8B1D13;
    color: #8B1D13;
    text-align: center;
  }

  .yht-backStage-zhgl_typeBtn:hover,
  .yht-backStage-zhgl_typeBtn.active {
    color: #fff;
    background-color: #8B1D13;
  }

  .yht-backStage-zhgl-content_btnBox {
    height: 36px;
  }

  .yht-backStage-zhgl-content_btn {
    width: 98px;
    height: 36px;
    line-height: 36px;
    color: #666666;
    text-align: center;
    border-radius: 4px;
    background: #FFFFFF;
    border: 1px solid #666666;
  }

  .yht-backStage-zhgl-content_btn:hover {
    color: #8B1D13;
    border-color: #8B1D13;
  }

  .yht-backStage-zhgl-content_search {
    position: absolute;
    top: 72px;
    right: 30px;
  }

  .zhgl-input{
    width: 360px;
    height: 38px;
    border-radius: 4px;
  }

  .zhgl-input .el-input__inner,
  .zhgl-input .el-input.is-active .el-input__inner,
  .zhgl-input .el-input__inner:focus,
  .zhgl-input .el-input__inner:hover{border-color: #ccc;}

  .zhgl-input >.el-input__inner {
    padding-right: 45px;
  }

  .yht-backStage-zhgl-content_search_icon {
    position: absolute;
    top: 50%;
    right: 10px;
    margin-top: -15px;
    width: 30px;
    height: 31px;
    background: url("../images/search.png");
    background-size: 100% 100%;
  }

  .yht-backStage-zhgl_table {
    width: 100%;
    height: calc(100% - 112px);
  }

  .yht-backStage-zhgl_page {
    position: relative;
    margin-top: 10px;
    width: 100%;
    height: 50px;
  }

  .yht-backStage-zhgl_page .el-pagination {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .yht-backStage-zhgl_table_status {
    position: relative;
    padding-left: 23px;
  }

  .yht-backStage-zhgl_table_status::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 0;
    width: 16px;
    height: 16px;
  }

  .yht-backStage-zhgl_table_status.online::before {
    background: url("../images/zhgl_on.png");
    background-size: 100% 100%;
  }

  .yht-backStage-zhgl_table_status.offline::before {
    background: url("../images/zhgl_off.png");
    background-size: 100% 100%;
  }

  .yht-backStage-zhgl_table_line {
    width: 16px;
    height: 16px;
    background: url("../images/icon_start.png");
    background-size: 100% 100%;
  }

  .yht-backStage-zhgl_table_line.offline {
    background: url("../images/icon_stop.png");
    background-size: 100% 100%;
  }

  .yht-backStage-zhgl_userInfo .el-form {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #EEEEEE;
  }

  .yht-backStage-zhgl_userInfo .el-form-item .el-form-item__content {
    width: 220px;
  }

  .yht-backStage-zhgl_userInfo .el-form-item .el-input__inner {
    background: #F0F0F0;
  }

  .yht-backStage-zhgl_privilege {
    width: 100%;
    height: 300px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 9px;
    color: #3d3d3d;
    overflow: auto;
  }

  .yht-backStage-zhgl_privilege_Liltitle {
    font-weight: bold;
  }

  .yht-backStage-zhgl_privilege_box {
    margin-top: 15px;
    padding-left: 30px;
  }

  .yht-backStage-zhgl_privilege_item {
    margin-bottom: 15px;
  }

  .yht-backStage-zhgl_privilege_check {
    margin-top: 4px;
    margin-right: 8px;
    width: 14px;
    height: 14px;
    background: url("../images/icon_normal.png");
    background-size: 100% 100%;
  }

  .yht-backStage-zhgl_privilege_check.active {
    background: url("../images/icon_checked.png");
    background-size: 100% 100%;
  }

  .yht-backStage-zhgl_privilege_name {
    margin-right: 100px;
  }

  .yht-backStage-zhgl_privilege_description {
    flex: 1;
    color: rgba(0, 0, 0, 0.6);
  }

  .yht-backStage-zhgl_btnBox {
    display: flex;
    justify-content: center;
  }

  .yht-backStage-zhgl_btn {
    width: 98px;
    height: 36px;
    line-height: 36px;
    color: #fff;
    border-radius: 4px;
    background: #8B1D13;
  }

  .yht-backStage-zhgl_btn:hover {
    background: #C85C52;
  }

  .yht-backStage-permission_userName {
    padding-bottom: 22px;
    border-bottom: 1px solid #eee;
  }

  .yht-backStage-permission_title {
    font-weight: bold;
  }

  .yht-backStage-permission_right {
    flex: 1;
  }

  .el-cascader__dropdown .el-cascader-node__label {
    width: 200px;
  }

  .el-cascader__dropdown .el-cascader-menu__list {
    width: 95%;
  }

  .yht-backStage-zhgl_select_item {
    display: block;
    width: 177px;
  }
</style>
